import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummaryGrid = styled(Box, {
  shouldForwardProp: prop => prop !== 'compact',
})(({ theme, compact }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(compact ? 1.25 : 2),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
}));
